<template>
  <div
    class="bjzc-banner uk-position-relative uk-visible-toggle uk-light"
    tabindex="-1"
    uk-slideshow="autoplay: true;autoplay-interval: 5000;max-height: 400;min-height: 150"
  >
    <ul class="uk-slideshow-items">
      <li v-for="banner in banners" :key="banner.id">
        <a v-if="banner.linkUrl" :href="banner.linkUrl">
          <img :src="$getLocaleValue(banner, 'imageUrl')" :alt="$getLocaleValue(banner, 'title')" uk-cover />
        </a>
        <img v-else :src="$getLocaleValue(banner, 'imageUrl')" :alt="$getLocaleValue(banner, 'title')" uk-cover />
      </li>
    </ul>

    <a
      class="uk-position-center-left uk-position-small uk-hidden-hover"
      href="#"
      uk-slidenav-previous
      uk-slideshow-item="previous"
    ></a>
    <a
      class="uk-position-center-right uk-position-small uk-hidden-hover"
      href="#"
      uk-slidenav-next
      uk-slideshow-item="next"
    ></a>

    <div class="uk-position-bottom-center uk-padding-small">
      <ul class="uk-slideshow-nav uk-dotnav"></ul>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      banners: [
        {
          id: 0,
          describe: '',
          imageUrl: require('@/assets/images/banner/banner-1.png'),
          linkUrl: '',
          title: 'default-image'
        }
      ]
    }
  },
  created() {
    this.$axios.get('/banners').then(res => {
      this.banners = res.data
    })
  },
  methods: {}
}
</script>

<style lang="scss">
/* banner */
.bjzc-banner {
  .uk-dotnav > * > * {
    background: rgba(252, 252, 252, 0.5);
    border-color: transparent;
  }
  .uk-dotnav > * > :hover,
  .uk-dotnav > .uk-active > * {
    background: #ff6600;
    border-color: transparent;
  }
}
</style>
